export const USER_SET_INFORMATIONS = 'USER_SET_INFORMATIONS';
export const USER_SET_ROLES = 'USER_SET_ROLES';
export const USER_SET_LIST_INFORMATION = 'USER_SET_LIST_INFORMATION';
export const USER_SET_TOKEN = 'USER_SET_TOKEN';
export const USER_SET_REQUEST_EMAIL = 'USER_SET_REQUEST_EMAIL';
export const USER_CONNECTED_TO_SURFER = 'USER_CONNECTED_TO_SURFER';
export const USERS_EDITED = 'USERS_EDITED';
export const USERS_ADDED = 'USERS_ADDED';
export const USERS_DELETED = 'USERS_DELETED';
export const USER_ADD_EVENT = 'USER_ADD_EVENT';
export const USER_SET_LANGUAGE = 'USER_SET_LANGUAGE';
